export default "__VITE_ASSET__CTNpi5BU__"